module.exports = __webpack_public_path__ + "img/maastopyora.a1164229.svg";